export default __webpack_public_path__ + "static/media/placeholder_store03-fr-mobile.930ae6fb.png";